


















































































































































































import { Component, Prop, PropSync, Vue, Ref, Watch } from "vue-property-decorator";
import { ListModel } from "@/shared/models/listModel";
import { DateTime } from "luxon";
import _ from "lodash";
import { Getter } from "vuex-class";
import RichTextEditor from "@/components/misc/RichTextEditor.vue";
import { PropertySpecialNotes } from "@/shared/models/property";
import { AccomodationUnitTypeUnitOwners, OfficialRateExportForOwners, OwnersAddOnServices } from "../types";
import { OfficialRatesExportType } from "@/shared/models/enums.type";
import { saveFile } from "@/shared/saveFile";
import { LanguageView } from "@/shared/models/languages";
 
const flagImages = require.context('@/assets/images/flags/', false, /\.png$/)
 
@Component({
  components: {RichTextEditor}
})
 
export default class OfficialRatesExportForOwners extends Vue {
  @PropSync("open") internalOpen?: boolean;
  @Prop() propertyId?: number;
  @Prop() accUnitTypeId?: number;
 
  @Getter("language/supportedLanguages") supportedLanguages?: LanguageView[];
  @Getter("language/language") language?: string;

  mounted() {
    this.cultureCode = this.language ?? "";
    this.loadSpecialNotes();
    this.getOwners();
    this.getOwnersAddOnServices();
  }
 
  officialRatesYear = DateTime.now().year;
  years = _.range(DateTime.now().year + 6, DateTime.now().year - 1, -1);

  specialNotes: PropertySpecialNotes[] = [];
  exportBody: OfficialRateExportForOwners = new OfficialRateExportForOwners;
  selectedOwners = [] as number[];
  selectedOwnersAddOnServices = [] as number[];
 
  cultureCode = "";
  specialNote = "";

  loading = false;

  officialRatesExportType = OfficialRatesExportType.InputPrice;

  officialRateExportShouldBeLandscape = false;
  officialRateExportForOwnerShouldSaveSpecialNote = true;

  editorToolbar = [
    [{'size': [ '16px', '32px', '24px', '18.7px', '14px', '12px' ]}],
    ["bold", "italic", "underline"],
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }],
  ];

  exportTypes = [
    {
      value: OfficialRatesExportType.InputPrice,
      text: "t.OfficialRateExport.InputPrice",
    },
    {
      value: OfficialRatesExportType.InputAndOutputPrice,
      text: "t.OfficialRateExport.InputAndOutputPrice",
    },
  ];
  
  @Watch('internalOpen')
  onOpenChanged(fresh: boolean) {
    if(fresh) {      
      this.cultureCode = this.language ?? "";
      this.loadSpecialNotes();
      this.getSpecialNote(this.cultureCode)
      this.getOwners();
      this.getOwnersAddOnServices();
    }
    this.form?.resetValidation();
  }
 
  @Ref('form') form?: {
    resetValidation: () => void;
    validate: () => boolean;
  };
 
  loadSpecialNotes() {
    this.loading = true;

    this.axios
      .get<ListModel<PropertySpecialNotes>>
        ("/Properties/" + this.propertyId + "/propertySpecialNotes")
      .then((res) => {
        this.specialNotes = res.data.result;
        this.getSpecialNote(this.cultureCode)
      })
      .finally(() => {
        this.loading = false;
      })
  }
 

  owners: AccomodationUnitTypeUnitOwners[] = [];
  getOwners() {
    this.loading = true;

    Vue.axios
      .get<AccomodationUnitTypeUnitOwners[]>(
        `/properties/${this.propertyId}/accomodationUnitTypesOwners/${this.accUnitTypeId ?? 0}`
      )
      .then((res) => {
        this.owners = res.data;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  ownersAddOnServices: OwnersAddOnServices[] = [];
  getOwnersAddOnServices() {
    this.loading = true;

    Vue.axios
      .get<OwnersAddOnServices[]>(
        `/properties/${this.propertyId}/ownersAddOnServices/${this.accUnitTypeId ?? 0}`
      )
      .then((res) => {
        this.ownersAddOnServices = res.data;
        this.selectedOwnersAddOnServices = res.data.map((x) => x.id)
      })
      .finally(() => {
        this.loading = false;
      })
  }

  imgSrc(lang: string) {
    return flagImages('./' + lang + ".png")
  }

  get getExportBody(){
    this.exportBody.propertyId = this.propertyId;
    this.exportBody.accUnitTypeId = this.accUnitTypeId;
    this.exportBody.ownerIds = this.selectedOwners.join(",");
    this.exportBody.ownerAddOnServiceIds = this.selectedOwnersAddOnServices.join(",");
    this.exportBody.languageCode = this.cultureCode;
    this.exportBody.specialNote = this.specialNote;
    this.exportBody.saveSpecialNote = this.officialRateExportForOwnerShouldSaveSpecialNote;
    this.exportBody.isLandscape = this.officialRateExportShouldBeLandscape;
    this.exportBody.exportType = this.officialRatesExportType;
    this.exportBody.year = this.officialRatesYear;

    return this.exportBody;
  }
  
  exportOfficialRates() {
    this.loading = true;
    const formValid = this.form?.validate();

    if(formValid){
      this.axios
        .post(`/properties/officialRates/exportForOwners`, 
          this.getExportBody, 
          { responseType: "blob" })
        .then((res) => {
          const groups = /filename="?(?<filename>[^;"]+)"?;/.exec(
            res.headers["content-disposition"]
          )?.groups;
          saveFile(res.data, groups?.filename ?? "OfficialRates.pdf");

          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("GenerateOfficialRatesSuccess"),
            timeout: 5000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    } else this.loading = false
  }
 
  getSpecialNote(event: string) {
    const specialNote = this.specialNotes.find(x => x.cultureCode === event);

    if (specialNote) {
      this.specialNote = specialNote.note;
    } else {
      this.specialNote = "";
    }
  }

  get rules() {
    return {
      atLeastOneSelected: (value: any[]) =>
        (!!value && value.length > 0) ||
        this.$t("Validation.Required").toString()
    };
  }
}
